<template>
  <div class="rich-audio-wrapper">
    <h4>{{ title }}</h4>
    <p class="description">{{ description }}</p>
    <img :src="icon.url" :alt="icon.accessibilityText" width="54">
    <audio controls class="rich-audio">
      <source :src="url" :type="type">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
export default {
  name: 'RichAudio',
  props: {
    url: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    icon: {
      type: Object,
      default: () => ({
        accessibilityText: '',
        url: String
      })
    }
  },
  computed: {
    type () {
      if (this.url) {
        return (this.url.split('.').pop()) === 'mp3' ? 'audio/mpeg' : 'audio/ogg'
      }

      return 'audio/mpeg'
    }
  }
}
</script>

<style lang="sass" scoped>
.description
  margin-bottom: 10px
</style>
